/**
 * Privacy policy configuration for this site. Rendered by `PrivacyPolicy` from
 * @mtrx/ui, which generates the PIPEDA wording from these facts.
 *
 * Only declare what the site ACTUALLY does — a policy that claims a feature the
 * site lacks is as wrong as one that omits a feature it has.
 */
export const privacyConfig = {
  businessName: 'Fateh Heating and Cooling',
  domain: 'fatehheatingandcooling.com',
  contactEmail: 'fatehheatingandcooling@gmail.com',
  effective: 'Aug 20, 2026',
  updated: 'Aug 20, 2026',
  // api/contact.js — these are the real fields the form posts.
  contactForm: {
    fields: [
      'Your name',
      'Your email address',
      'Your phone number',
      'The service you need',
      'How you would prefer to be contacted',
      'The details of your message',
    ],
    autoReply: true,
  },
  cms: false,
  // initTracking({ slug: 'fateh-hvac' }) in src/main.jsx
  analytics: true,
  // Google Analytics (src/lib/gtag.js, gated on VITE_GA_MEASUREMENT_ID) sets its
  // own cookies, so it belongs in the cookie table, not just the provider list.
  embeds: [
    { name: 'Google Analytics', purpose: 'Measures how visitors use the site' },
  ],
  extraProviders: [
    ['Vercel Analytics', 'Cookieless aggregate traffic measurement', 'United States'],
  ],
}

/** Site palette — see tailwind.config. */
export const privacyTheme = {
  page: 'bg-white',
  eyebrow: 'text-blue-700',
  title: 'text-slate-900',
  heading: 'text-slate-900',
  body: 'text-slate-600',
  muted: 'text-slate-500',
  link: 'text-blue-700 decoration-blue-300 hover:decoration-blue-700',
  border: 'border-slate-200',
  panel: 'bg-slate-50',
  bullet: 'before:bg-blue-600',
  focus: 'focus-visible:outline-blue-700',
}
